import { render, staticRenderFns } from "./SettingsSidePanel.vue?vue&type=template&id=3ef99dbe&scoped=true"
import script from "./SettingsSidePanel.vue?vue&type=script&lang=js"
export * from "./SettingsSidePanel.vue?vue&type=script&lang=js"
import style0 from "./SettingsSidePanel.vue?vue&type=style&index=0&id=3ef99dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef99dbe",
  null
  
)

export default component.exports